(function ($) {
  $(document).ready(function () {
    // var $sticky = $('body.product .container .column.product__images');
    // $sticky.hcSticky({
    //   stickTo: 'body.product .product_section.js-product_section'
    // });
    // $sticky.hcSticky('update', {
    //   responsive: {
    //     767: {
    //       disable: true
    //     }
    //   }
    // });

    $('.quickshop-close').click(function () {
      $.fn.fancybox.close()
    })
    if ($('.quantity-wrapper .quantity-select-control').length > 0) {
      $('.quantity-wrapper .quantity-select-control label').click(function () {
        $(this).toggleClass('active').next('ul').slideToggle();
      })
      $('.quantity-wrapper .quantity-select-control ul li').click(function () {
        var valQty = $(this).attr('value');
        $(this).parent('ul').slideUp();
        $(this).parents('.control.quantity-select-control').find('label').removeClass('active').text(valQty);
        $(this).parents('.purchase-details__quantity.product-quantity-box').find('.quantity-input-control input').val(valQty);
      })
    }

    if ($('.product_section .what-inside-slider').length > 0) {
      $('.product_section .what-inside-slider').owlCarousel({
        loop: false,
        nav: true,
        dots: false,
        margin: 45,
        items: 4,
        responsive: {
          0: {
            items: 1,
            margin: 20,
            dots: true,
            nav: false,
            center: true,
            loop: true,
            onInitialized: callback
          },
          767: {
            items: 3,
            margin: 10,
            dots: true,
            nav: false,
            center: true,
            loop: true
          },
          768: {
            items: 3,
            margin: 10
          },
          1200: {
            items: 4
          },
        }
      });
      function callback(event) {
        var items = event.item.count;
        console.log(items);
        if (items <= 1) {
          $('.owl-carousel .owl-stage').addClass("single");
        }
      }
    }


    if ($('.products-related-slider').length > 0) {
      $('.products-related-slider').owlCarousel({
        loop: false,
        nav: false,
        dots: false,
        margin: 40,
        items: 4,
        responsive: {
          0: {
            items: 1,
            margin: 17,
            loop: true
          },
          375: {
            items: 2,
            margin: 17,
            loop: true
          },
          767: {
            items: 2,
            margin: 17,
            nav: false,
            loop: true
          },
          768: {
            items: 3,
            margin: 30
          },
          1200: {
            items: 4
          }
        }
      });
    }

    if ($('.product-tab').length > 0) {
      $('.product-tab-item h6').click(function () {
        $(this).toggleClass('active').next('.content').slideToggle();
        // $(this).parent('.product-tab-item').siblings('.product-tab-item').find('.content').slideUp();
        // $(this).parent('.product-tab-item').siblings('.product-tab-item').find('h6').removeClass('active');
      });
    }

    //match height
    function alignHeight(element) {
      $(element).css({ 'height': '' });
      var minHeight = '';
      $(element).each(function () {
        if (minHeight < $(this).outerHeight()) {
          minHeight = $(this).outerHeight();
        }
      })
      if (minHeight > 0) {
        $(element).css({ 'height': minHeight });
      }
    }

    if (jQuery('.product_feature-item.product_feature-in').length) {

      if ($(window).width() <= 767) {

        alignHeight('.product_feature-item.product_feature-in ul li');

        $(window).resize(function () {
          alignHeight('.product_feature-item.product_feature-in ul li');

        })
      }
    }

    setTimeout(function () {
      if (jQuery('.inside-item h6').length) {

        alignHeight('.inside-item h6');

        $(window).resize(function () {
          alignHeight('.inside-item h6');

        })

      }

    }, 300);


    if ($('.page-content.holding-popup').length > 0) {
      productReviewAuthor(0);
      function productReviewAuthor(c) {
        setTimeout(() => {
          if ($('.ssw-recomends-list .ssw-recommend-author').text().length > 0) {
            var verifiedReviewer = $('.product-app').attr('data-verified-reviewer');
            $('<div class="verified-reviewer"><span>' + verifiedReviewer + '</span></div>').insertAfter('.ssw-user-subheader');
          } else {
            productReviewAuthor(c + 1)
          };
        }, 1000);
      }


      setTimeout(function () {
        newsletterPopup();
      }, 1000);
      jQuery('.icon-popup-newsletter').click(function () {
        if ($('body.fancybox-active').length > 0) {
          $.fancybox.close($('[data-popup]'));
        } else {
          newsletterPopup();
        }
      });
    }
    var url = window.location.href;
    if (url.includes('product-section-review')) {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('#ssw-widget-recommends-html').offset().top
        }, 'slow');
      }, 10000);
    }

    $('.product_feature-item .feature-item-open').click(function () {
      $(this).parents('.product_feature-item').toggleClass('active');
    });
    $('.product_feature-item .feature-item-close').click(function () {
      $(this).parents('.product_feature-item').removeClass('active');
    })
    $('.product-feature-waterless-item .feature-item-open').click(function () {
      $(this).parents('.product-feature-waterless-item').toggleClass('active');
    });
    $('.product-feature-waterless-item .feature-item-close').click(function () {
      $(this).parents('.product-feature-waterless-item').removeClass('active');
    })

    // Product image icon split
    // $('.product-icon-title-text').lettering();
    if($('.product-icon-title-text').length>0) {
      const textDesktop = document.querySelector(".product-icon-title-text.visible-desktop");
      const textMobile = document.querySelector(".product-icon-title-text.visible-mobile");

      textDesktop.innerHTML = textDesktop.innerText.split("").map(
          (char, i) => `<span style="transform:rotate(${12 + (i * 5.7)}deg)">${char}</span>`
        ).join("");

      textMobile.innerHTML = textMobile.innerText.split("").map(
          (char, i) => `<span style="transform:rotate(${12 + (i * 8)}deg)">${char}</span>`
        ).join("");
    }

    // Product tab view all
    $('.custom-tab-2-items .view-all').click(function (e) {
      e.preventDefault();
      $(this).hide();
      $('.custom-tab-2-item:hidden').css('display', 'flex');
    });

    // How it works
    // $('.hiw-information').owlCarousel({
    //   loop: true,
    //   nav: false,
    //   dots: false,
    //   margin: 55,
    //   items: 4
    // });
  });
  function newsletterPopup() {
    $.fancybox.open({
      src: '[data-popup]',
      type: 'inline',
      opts: {
        baseClass: 'popup-modal popup__newsletter',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: () => {
          // Remove previous slides (fix for theme editor)
          $('.popup-modal .fancybox-slide').empty();
        },
        afterShow: () => {
          // After content is loaded, attach event listener for custom close icon
          $(document).on('touchstart click', '.popup__close', () => {
            $.fancybox.close($('[data-popup]'));
          });
        },
        beforeClose: () => {
          // Prevent duplicate triggers for close icon click
          $('.popup__close').off();
        }
      }
    });
  }

  //Custom reCharge
  var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };

  waitForEl('.rc_container_wrapper', function () {
    var subcriptionElement = $('.subcribe-label').closest('.product_form').find('.rc_container_wrapper');
    $(subcriptionElement).insertAfter('.subcribe-label');
    $('.rc_widget__price--onetime').each(function (index, obj) {
      var originalPrice = $(obj).text();
      var originalPriceText = '<span class="rc-option__price rc_widget__price rc_widget__price--subsave original-price" aria-label="recurring price" data-price-subsave="">' + originalPrice + '</span>';
      var subsaveElement = $(obj).closest('.rc-template').find('.rc_widget__price--subsave');
      $(originalPriceText).insertBefore(subsaveElement);
    });
    $('.rc-option__subsave').each(function (index, obj) {
      var priceHtml = '<span class="rc-option__price-wrapper"></span>';
      $(this).find('label.rc-radio__label').append(priceHtml);
      var priceHtmlWrap = $(this).find('.rc-option__price-wrapper')
      $(this).find('.rc-option__price').appendTo(priceHtmlWrap);
    });

    var subcribeTextMobile = $('.subcribe-label').attr('data-label-text-subsave-mobile');
    if ($(window).width() < 768) {
      $('.subcribe-label').closest('.product_form').find('.rc-radio.rc-option__subsave').find('.rc-option__text').text(subcribeTextMobile);
    }
  });
})(jQuery);